import React from 'react';
import { Select } from 'antd';
import { ChannelType } from '../graphql/types/ChannelType';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import { useFilterContainerClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';
import { getSmartLabelClassName } from '../../../../utils/labelWidthUtils';

export type ChannelFilterOptions = {
    channelId: string;
    channelName: string;
    status: 'all' | 'In Business' | 'Suspended';
};

export const DEFAULT_CHANNEL_FILTER_OPTIONS: ChannelFilterOptions = {
    channelId: '',
    channelName: '',
    status: 'all'
};

interface FilterAreaProps {
    filters: ChannelFilterOptions;
    setFilters: (filters: ChannelFilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
    const {t} = useTranslation();
    const containerClassName = useFilterContainerClassName();
    const inputContainerClassName = useFilterInputContainerClassName();
    const col1SpanClassName = getSmartLabelClassName([t('central.channels.filters.id')]);
    const col2SpanClassName = getSmartLabelClassName([t('central.channels.filters.name')]);
    const col3SpanClassName = getSmartLabelClassName([t('central.channels.filters.status')]);

    return (
        <div className="mb-2 py-2">
            {/* 使用 Grid 布局确保列对齐 */}
            <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
                {/* 第一列 - 统一宽度 w-[48px]（3字：客户ID） */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.channels.filters.id')}
                        value={filters.channelId}
                        onChange={(e) => setFilters({ ...filters, channelId: e.target.value })}
                        spanClassName={col1SpanClassName}
                    />
                </div>
                {/* 第二列 - 统一宽度 w-[60px]（4字：客户名称） */}
                <div className="min-w-0">
                    <InputFilterItem
                        label={t('central.channels.filters.name')}
                        value={filters.channelName}
                        onChange={(e) => setFilters({ ...filters, channelName: e.target.value })}
                        spanClassName={col2SpanClassName}
                    />
                </div>
                {/* 第三列 - 统一宽度 w-[36px]（2字：状态） */}
                <div className="min-w-0">
                    <div className={containerClassName}>
                        <span className={col3SpanClassName}>{t('central.channels.filters.status')}</span>
                        <div className={inputContainerClassName}>
                            <Select
                                placeholder={String(t('components.input.all'))}
                                className="w-full"
                                size="middle"
                                value={filters.status}
                                onChange={(value) => setFilters({ ...filters, status: value })}
                                options={[
                                    { value: 'all', label: t('enum.activeStatus.all') },
                                    { value: 'In Business', label: t('enum.activeStatus.active') },
                                    { value: 'Suspended', label: t('enum.activeStatus.suspended') },
                                ]}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FilterArea; 